import { StartupService } from '../../../services/startup.service';
import { ModalComponent } from '../../shared/modal/modal.component';
import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Color, ColorGroup, VisualizerResponse } from '../../../models/color.model';
import { Modal } from '../../../models/qa.model';
import { QuestionTypeEnum } from '../../../models/question-type';
import { Empty } from '../../../models/utils.model';
import { QaService } from '../../../services/qa.service';
import { AnswerInfoService } from '../../../services/answer-info.service';
import { ScrollingService } from '../../../services/scrolling.service';
import { WoodTypeEnum } from '../../../models/wood-type';
import { TranslatableOpacities } from '../../../models/color.model';
import { VisualizerService } from '../../../services/visualizer.service';

@Component({
  selector: 'app-opacity-colors',
  templateUrl: './opacity-colors.component.html',
  styleUrls: ['./opacity-colors.component.scss']
})
export class OpacityColorsComponent implements OnInit {
  @Input() public colorGroup: ColorGroup;
  @Input() public OpacityGUID: string;
  public translatableOpacities: TranslatableOpacities[];
public translatedOpacity: TranslatableOpacities;
  public opacityValue: number;
  @ViewChild('tooltip') modalTooltip: ModalComponent;
  @ViewChild('colorGroupTitle') colorGroupTitle;
  @ViewChild('colorContainer') colorContainer;
  @ViewChild('columnContainer') columnContainer;
  public modal: Modal;
  public opacityName: string;
  public colors: Color[][];
  // public unorderedColors: Color[];

  private pickedCedarOrRedwoodOrComposite: boolean = false;

  constructor(
    public visualizerService: VisualizerService,
    private startupService: StartupService,
    private qaService: QaService,
    private answerInfoService: AnswerInfoService,
    private renderer: Renderer2,
    private scrollingService: ScrollingService
  ) { }

  ngOnInit() {
    this.opacityValue = this.colorGroup.OpacitySwatchTransparency;
    this.opacityName = this.colorGroup.OpacityName;
    const image = this.startupService.startupData.PopupImages.find(i =>
      i.PopupFilter === this.colorGroup.PopupFilter &&
      i.WoodType === this.answerInfoService.getSelectedWoodType()
    );

    // tslint:disable-next-line: max-line-length
    this.pickedCedarOrRedwoodOrComposite = this.answerInfoService.getSelectedWoodType() === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.Cedar) ||
                                this.answerInfoService.getSelectedWoodType() === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.Redwood) ||
                                // tslint:disable-next-line: max-line-length
                                this.answerInfoService.getSelectedWoodType() === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.Composite);

    // Only show the best colors (elite mostly) for Cedar and Redwood
    if (this.pickedCedarOrRedwoodOrComposite) {
      const opacityColors = this.colorGroup.OpacityColors;
      // const allColors = [];
      // If the group doesn't contain an elite color
      opacityColors.forEach((x) => {
        x.forEach((color) => {
          color.IsElite = false;
        });
      });

      this.colors = opacityColors;

    } else {
      this.colors = this.colorGroup.OpacityColors;
    }

    this.scrollingService.currentMessage.subscribe(message => {
      const containerRect = this.columnContainer.nativeElement.getBoundingClientRect();
      const titleRect = this.colorGroupTitle.nativeElement.getBoundingClientRect();

      if (
        containerRect.left < (message.valueOf() + 12) &&
        containerRect.right > message
      ) {
        this.renderer.setStyle(
          this.colorGroupTitle.nativeElement,
          'right',
          ((containerRect.right - message.valueOf()) - titleRect.width) + 'px'
        );

        if (((containerRect.right - titleRect.width) - 12) <= message) {
          this.renderer.setStyle(this.colorGroupTitle.nativeElement, 'right', '.75rem');
        }
      } else {
        this.renderer.setStyle(this.colorGroupTitle.nativeElement, 'left', 'auto');
        this.renderer.setStyle(this.colorGroupTitle.nativeElement, 'right', 'auto');
      }
    });

    this.translatableOpacities = this.visualizerService.visualizerData.Opacities;
    this.translatedOpacity = this.translatableOpacities.find(c => c.OpacityGUID === this.colorGroup.ItemGUID);
    // console.log(this.translatedOpacity);

    this.modal = new Modal({
      HideModal: true,
      Image: image ? image.PopupImage : '',
      Title: this.translatedOpacity.DocumentName,
      Text: this.translatedOpacity.OpacityDescption,
      ButtonText: this.startupService.startupData.BrandInfo.GotItTranslation
    });
  }

  showInfo() {
    this.modalTooltip.modal.HideModal = false;
    this.modalTooltip.modal.modalStatus(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/visualizer/opacity-colors/opacity-colors.component.ts